/** Session flag set when Supabase fires PASSWORD_RECOVERY (email reset / dashboard recovery). */

export const PASSWORD_RECOVERY_STORAGE_KEY = 'omnis_password_recovery'

export function markPasswordRecovery(): void {
  try {
    sessionStorage.setItem(PASSWORD_RECOVERY_STORAGE_KEY, '1')
  } catch {
    // ignore quota / private mode
  }
}

export function clearPasswordRecovery(): void {
  try {
    sessionStorage.removeItem(PASSWORD_RECOVERY_STORAGE_KEY)
  } catch {
    // ignore
  }
}

export function isPasswordRecoveryPending(): boolean {
  try {
    return sessionStorage.getItem(PASSWORD_RECOVERY_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/** Call on boot: recovery links include type=recovery in hash or query before PASSWORD_RECOVERY fires. */
export function detectRecoveryFromUrl(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const hash = window.location.hash || ''
    const search = window.location.search || ''
    if (
      /(?:^|[?#&])type=recovery(?:&|$)/.test(hash) ||
      /(?:^|[?&])type=recovery(?:&|$)/.test(search)
    ) {
      markPasswordRecovery()
      return true
    }
  } catch {
    // ignore
  }
  return false
}
